import { render, staticRenderFns } from "./scratch-text.vue?vue&type=template&id=e0835886"
import script from "./scratch-text.vue?vue&type=script&lang=js"
export * from "./scratch-text.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_business_lcPT/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e0835886')) {
      api.createRecord('e0835886', component.options)
    } else {
      api.reload('e0835886', component.options)
    }
    module.hot.accept("./scratch-text.vue?vue&type=template&id=e0835886", function () {
      api.rerender('e0835886', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/research/curriculum-manage/components/scratch-text.vue"
export default component.exports